'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdMovieFilter = function MdMovieFilter(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm28.2 19.9l3.4-1.5-3.4-1.6-1.6-3.4-1.5 3.4-3.5 1.6 3.5 1.5 1.5 3.5z m-9.4 5.5l4.6-2-4.6-2.2-2.2-4.6-2 4.6-4.6 2.2 4.6 2 2 4.6z m11.2-18.8h6.6v23.4c0 1.8-1.4 3.4-3.2 3.4h-26.8c-1.8 0-3.2-1.6-3.2-3.4v-20c0-1.8 1.4-3.4 3.2-3.4h1.8l3.2 5h5l-3.2-5h3.2l3.4 5h5l-3.4-5h3.4l3.4 5h5z' })
        )
    );
};

exports.default = MdMovieFilter;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/movie-filter.js
// module id = 3087
// module chunks = 0